import Text from 'shared/components/Text/Text';
import styled, { css } from 'styled-components';

export const OnboardingMilestoneBaseContainer = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const OnboardingMilestoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 32px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    gap: 72px;
  }
`;

export const OnboardingMilestoneContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Title = styled(Text)`
  font-weight: 500;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    font-weight: 700;
  }
`;

export const OnboardingMilestoneContentText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 557px;
`;

export const OnboardingMilestoneContentTextHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  div {
    height: fit-content;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const OnboardingMilestoneContentTextBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const OnboardingMilestoneContentVideo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 12px;
`;

export const OnboardingMilestoneDetails = styled.div`
  ${({ theme }) => css`
    border-radius: 24px;
    padding: 32px 20px;
    background: ${theme.colors.backgroundSecondaryGrey05};
    box-shadow: ${theme.elevations.extraSunken};
    height: fit-content;
  `}
  h2 {
    margin-bottom: 16px;
  }
`;

export const OnboardingMilestoneDetailsCardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 24px;

  > div {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    margin: 0;
    max-width: unset;
    flex: 1;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const ULStyled = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding-left: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 12px;
  }
`;

export const VideoPlayerWrapper = styled.div<{ $hideBorder: boolean }>`
  width: 100%;
  min-height: 214px;
  align-self: center;
  border: 1px solid
    ${({ theme, $hideBorder }) =>
      $hideBorder ? 'transparent' : theme.colors.strokeSecondaryGrey10};
  border-radius: ${($hideBorder) => ($hideBorder ? 0 : '8px')};

  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    width: 307px;
    align-self: flex-start;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    width: 345px;
  }
`;
